module.exports = __webpack_public_path__ + "img/Martin Baric.8427c5a0.jpg";